export default "__VITE_ASSET__dc2cf2a8__"